import { render } from "./UpdatePta.vue?vue&type=template&id=702f4b09&scoped=true&ts=true"
import script from "./UpdatePta.vue?vue&type=script&lang=ts"
export * from "./UpdatePta.vue?vue&type=script&lang=ts"

import "./UpdatePta.vue?vue&type=style&index=0&id=702f4b09&scoped=true&lang=scss"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-702f4b09"]])

export default __exports__